import React, {useState, Component, Fragment} from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import Iframe from "react-iframe"
import { Redirect,Link } from 'react-router-dom';
import { Placeholder,Popup } from 'semantic-ui-react';
import {
  Menu,
  Container,
  Segment,
  Table,
  Divider,
  Message,
  Icon,
  Header,
  Dimmer,
  Responsive,
  Modal,
  Button,
  Image,
  Loader,
  Tab,
  Label
} from 'semantic-ui-react';
import {Base64} from 'js-base64';
import QRCode from 'qrcode.react';
import Clipboard from 'react-clipboard.js';

function Notes(){
  return <>
  <span>An American App Store account is required for the US App Store. If you do not have an account, please purchase one.</span>
  <a href="https://appleid.glados.top">US App Store account (for temporary use only, long-term availability not guaranteed):</a>，Please log in to the US App Store before use. <a href="https://appleid.glados.top">Redeem code for the US App Store</a>
  <Popup trigger={<span>[?]</span>} content='The App Store is divided into Chinese and US regions, and Shadowrocket is only available on the US App Store. Please use a US App Store ID to download US region apps. If you have your own US App Store ID (or any non-Chinese mainland ID), please use it. If you do not have an ID, we recommend purchasing a temporary US App Store ID and logging in with it to purchase the app.' inverted />
</>
}

function Guide(props){

  const mobile    = /Android|iPhone|iPod/.test(navigator.userAgent);
  const port      = props.data.port;
  const prefix    = props.data.prefix;
  const code      = props.data.code;
  const hashed    = props.data.hashed;
  const user_id   = props.data.user_id;
  const user_vip  = props.data.user_vip;
  const days      = props.data.days;

  //subscribe_endpoint = "update.glados-config.net";
  //subscribe_endpoint = "update.glados-config.org";
  var subscribe_endpoint = "update.glados-config.com";

  const sub    = 'sub://' + Base64.encode(`https://${subscribe_endpoint}/subscribe/${user_id}/${code}/${port}/servers`) + "#Github.com/GLaDOS-network";
  const quantumultx  = `https://${subscribe_endpoint}/quantumultx/${user_id}/${hashed}`;
  const loon   = `https://${subscribe_endpoint}/loon/${user_id}/${hashed}/glados.network.conf`;
  const v2ray  = `https://${subscribe_endpoint}/v2ray/${user_id}/${hashed}`;
  const suburl = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados.yaml`
  const [url,setURL] = useState(false);
  const [clipboard,setClipboard] = useState(false);

  if(url){
    return <Redirect to={url}/>
  }

  return (
  <Fragment>

    <Header color="blue" as='h2'>
      Guide to iOS Configuration.
      <Header.Subheader>
        Connecting to the GLaDOS network on iPhone/iPad.
      </Header.Subheader>
    </Header>

    <p>Please purchase the following client on your iPhone/iPad, we recommend purchasing Stash.</p>
    <p>Subsequently, configure the client by following steps. </p>

    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan='3'>
        <svg id="apple" style={{"color":"#333","height":"24px","width":"26px","marginRight":"8px", "verticalAlign": "middle"}}   viewBox="0 0 36 24">
          <path fillRule="evenodd" clipRule="evenodd" d="M18.7954 2.08851C20.3723 0.0101142 22.5646 0 22.5646 0C22.5646 0 22.8906 1.95403 21.3241 3.8364C19.6514 5.8464 17.7501 5.51751 17.7501 5.51751C17.7501 5.51751 17.3931 3.93677 18.7954 2.08851V2.08851ZM17.9507 6.88629C18.7619 6.88629 20.2675 5.77114 22.2273 5.77114C25.6007 5.77114 26.9279 8.17157 26.9279 8.17157C26.9279 8.17157 24.3323 9.4986 24.3323 12.7186C24.3323 16.3511 27.5657 17.6031 27.5657 17.6031C27.5657 17.6031 25.3054 23.9648 22.2524 23.9648C20.8502 23.9648 19.7601 23.0199 18.2826 23.0199C16.7771 23.0199 15.283 24 14.3098 24C11.522 24.0001 8 17.9653 8 13.1144C8 8.34171 10.9811 5.838 13.7773 5.838C15.5951 5.838 17.0057 6.88629 17.9507 6.88629V6.88629Z" fill="currentColor"/>
        </svg>
        </Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>

        <Segment>

          <Tab menu={{ color:"blue",  secondary: true }} panes={[
    {
      menuItem:<Menu.Item key='pro222'>
        Stash [recommend]
      </Menu.Item>,
      desktop:true,
      mobile:true,
      render: () => {
        return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>
          <p style={{color:"black"}}>1. 美区 App Store 购买 <a  href="https://stash.ws">Stash</a>[或者通过<a href="https://appleid.glados.top">充值兑换码</a>在美区 App Store 充值后购买(<a href="https://appleid.glados.top">需要登陆美区ID</a>)]</p>
          <p>2. 点击 Stash 左上角图标，选择导入，从URL下载，并输入<br/>
            <Clipboard
              style={{"borderRadius": "5px", "padding": "3px","borderWidth":"1px"}}
              onSuccess={()=>{ setClipboard(true) }}
              data-clipboard-text={suburl}>
              { clipboard ? "copied" : "copy to clipboard" }
            </Clipboard>
            <Label>{suburl}</Label>
          并点击下载
          </p>
          <p>3. 选择配置文件为GLaDOS</p>
          <p>4. 回到 Stash 主界面, 点击启动</p>
          <p>5. 如果遇到问题，请确保系统升级到15.0以上</p>
        </Tab.Pane>)
      }
    },
            { menuItem: 'Shadowrocket', render: () => <Tab.Pane>

              <p>苹果用户可以方便的使用GLaDOS。</p>
              <p>初次配置有 4 个步骤，请耐心按照教程操作, 安装小火箭(Shadowrocket)到iPad和iPhone。</p>
              <p>Step 1: 安装小火箭(Shadowrocket) 。小火箭是美区付费 App, 如果您没有 App, 你需要在美区 App Store 购买。</p>
              <p><Notes/></p>
              <p>Step 2: 进入 APP 后, 点击左上角的扫描按钮，扫描下面二维码</p>
              <br/>
              <QRCode value={sub} size={192} />
              <Divider />
              <br/>
              <p>Step 3: 同步节点后，选择第一个节点</p>
              <br/>
              <p>Step 4: 开启连接，此时系统会请求 VPN 权限，通过后配置就完成了.</p>
              <p>Step 5: 打开 Google.com 测试.</p>
              <p>Step 6: 滑动小火箭的 GLaDOS Profile ，完成一次配置文件更新.</p>

              <p>如果不能扫描，请通过URL订阅 GLaDOS 的服务器:</p>
              <p>
                <Clipboard
                  style={{"borderRadius": "5px", "padding": "4px"}}
                  onSuccess={()=>{ setClipboard(true) }}
                  data-clipboard-text={`https://${subscribe_endpoint}/subscribe/${user_id}/${code}/${port}/servers`}>
                  { clipboard ? "copied" : "copy to clipboard" }
                </Clipboard>
                <Label style={{fontSize:"1.1em"}}>https://{subscribe_endpoint}/subscribe/{user_id}/{code}/{port}/servers</Label>
              </p>

            </Tab.Pane> },
            { menuItem: 'QuantumultX', render: () => <Tab.Pane>

              <Message id="m4" style={{boxShadow:"none"}}>
                <Message.Header>QX 有限支持提示</Message.Header>
                <p>客户端仅支持部分服务器, 我们推荐您使用Stash/Shadowrocket/Clash</p>
              </Message>
              <p>QuantumultX iOS 是美区付费软件, 功能复杂, 不适合一般用户, 仅推荐熟悉的用户使用。</p>
              <p>为了用户自行配置，仅提供节点文件, 不提供规则以及其他配置文件.</p>
              <p><b>节点订阅</b>文件是: <br/>
                <Clipboard
                  style={{"borderRadius": "5px", "padding": "4px"}}
                  onSuccess={()=>{ setClipboard(true) }}
                  data-clipboard-text={quantumultx}>
                  { clipboard ? "copied" : "copy url" }
                </Clipboard>
                <Label>{quantumultx}</Label></p>

              <p>配置方法:</p>
              <p>1. 进入QuantumultX, 点击右下角的三角</p>
              <p>2. 在节点部分选择引用订阅, 在后面的弹窗中输入 {quantumultx}, 然后同步订阅</p>
              <p>使用方法:</p>
              <p>1. 回到首页选择节点，展开最新的订阅，然后选择一个节点。</p>
              <p>2. 在右上角点击代理开关</p>
              <p>备注: QuantumultX/Shadowrocket 不支持自动测速，因此我们没有提供全部可用节点，全部节点只在支持 Clash 的软件上。提供的部分节点速度和可用性较高，手动选择更方便。</p>

            </Tab.Pane> },
             { menuItem: 'Loon', render: () => <Tab.Pane>

              <Message id="m4" style={{boxShadow:"none"}}>
                <Message.Header>Loon 有限支持提示</Message.Header>
                <p>客户端仅支持部分服务器, 我们推荐您使用Stash/Shadowrocket/Clash</p>
              </Message>
              <p>Loon iOS 是美区付费软件, 请自己购买。</p>
              <p>Loon 配置文件是:<br/>
                <Clipboard
                  style={{"borderRadius": "5px", "padding": "4px"}}
                  onSuccess={()=>{ setClipboard(true) }}
                  data-clipboard-text={loon}>
                  { clipboard ? "copied" : "copy url" }
                </Clipboard>
                <Label>{loon}</Label></p>

              <p>配置方法:</p>
              <p>1. 进入Loon, 点击 Profile - Download from URL</p>
              <p>2. 在后面的弹窗中输入 {loon}, 然后同步</p>

            </Tab.Pane> },
            { menuItem: 'About US Apple ID', render: () => <Tab.Pane>
              <p>
              Choc/Stash/Shadowrocket/QuantumultX/Loon/Surge are not available for purchase on the China App Store.
              </p>
              <p>
              Please try purchasing them from other regional App Stores. If you don't have an account for these regions (such as the US or Japan), you can purchase a temporary Apple ID from <a href="https://appleid.glados.top">here</a> and then change the account details to your own email and security information.
              </p>
              <p>
              Please note that only an Apple ID linked to a US credit card can be used long-term. We do not recommend storing important information on a US App Store account. It is best to use the purchased Apple ID solely for logging into the App Store to download apps. 
              </p>
              <p>
              For privacy and data sync services, please use your domestic Apple ID.
              </p>

            </Tab.Pane>
            }
          ]} />

      </Segment>

    </Table.Body>
  </Table>

</Fragment>
  )
}
export {Guide};
